export default __webpack_public_path__ + "static/img-articolo-ottobre1-d076827fa2c348d56d2b25a3d8e2bb47.jpg";